import styled from 'styled-components/macro';

import { rem } from '@blueprint/ui';

import { ListItem } from 'components/blueprint';
import { colors } from 'themes';

const borderColor = colors.formElements[12];

export const SuggestionListItem = styled(ListItem)`
  && {
    cursor: pointer;
    padding: ${rem(5)} ${rem(10)};
    border-bottom: ${rem(1)} solid ${borderColor};
  }

  &.selected {
    outline: ${colors.surfaceDark} auto ${rem(1)};
  }

  &:first-child {
    padding-top: ${rem(10)};
  }

  &:last-child {
    padding-bottom: ${rem(10)};
    border-bottom: none;
  }
`;

export const getListItemId = (itemIndex) =>
  `get-support-entry-input-suggestion-list-item-${itemIndex}`;
